import Service from 'src/setup/network';
import { Dispatch } from 'redux';
import {
  FETCH_SALES_FAILURE,
  FETCH_SALES_REQUEST,
  FETCH_SALES_SUCCESS,
  FETCH_ORDER_TYPES_SUCCESS,
  FETCH_PAYMENT_SUCCESS,
  SalesActionType,
} from '../types/salesType';
import { fetchUsersOrder } from './currentOrder.action';
import { User } from 'src/types/model';
import { CurrentOrderActionType } from '../types/currentOrderType';

export const fetchSalesRequest = (): SalesActionType => ({
  type: FETCH_SALES_REQUEST,
});

export const fetchSalesSuccess = (data: any): SalesActionType => ({
  type: FETCH_SALES_SUCCESS,
  payload: data,
});

export const fetchSalesFailure = (error: string): SalesActionType => ({
  type: FETCH_SALES_FAILURE,
  payload: error,
});

export const fetchOrderTypesSuccess = (data: any): SalesActionType => ({
  type: FETCH_ORDER_TYPES_SUCCESS,
  payload: data,
});

export const fetchPaymentSuccess = (data: any): SalesActionType => ({
  type: FETCH_PAYMENT_SUCCESS,
  payload: data,
});

export const fetchSales = () => {
  return async (
    dispatch: Dispatch<SalesActionType | CurrentOrderActionType>
  ) => {
    dispatch(fetchSalesRequest());
    try {
      const request = await Service.get('/sales');
      const data: any = request?.data;
      dispatch(fetchSalesSuccess(data));
      const customers: User[] = data.customers || [];
      dispatch(fetchUsersOrder(customers));
    } catch (error: any) {
      dispatch(fetchSalesFailure(error?.message));
      throw new Error('Failed to fetch table');
    }
  };
};
